import { render, staticRenderFns } from "./r-point.vue?vue&type=template&id=9271e3e8"
import script from "./r-point.vue?vue&type=script&lang=js"
export * from "./r-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9271e3e8')) {
      api.createRecord('9271e3e8', component.options)
    } else {
      api.reload('9271e3e8', component.options)
    }
    module.hot.accept("./r-point.vue?vue&type=template&id=9271e3e8", function () {
      api.rerender('9271e3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-point.vue"
export default component.exports